import { render, staticRenderFns } from "./ShippingsPackagesTable.vue?vue&type=template&id=493adee8"
import script from "./ShippingsPackagesTable.vue?vue&type=script&lang=js"
export * from "./ShippingsPackagesTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports